import { render } from "./PreschoolDimensionsContent.vue?vue&type=template&id=5f6d395a&ts=true"
import script from "./PreschoolDimensionsContent.vue?vue&type=script&lang=ts"
export * from "./PreschoolDimensionsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__